import { FC, useEffect, useRef } from 'react';
import { Textarea } from '../ui/textarea';
import { cn } from 'lib/utils';
import { TextareaPart, textareaState } from './textarea';
import { uiInput } from '../CutCorners';
import React from 'react';

interface BPTexareaProps {
  twWidth?: string | null;
  twHeight?: string | null;
  placeholder?: string;
  value?: string;
  disabled?: boolean;
  focus?: boolean;
  hideResize?: boolean;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
}

const BPTextarea: FC<BPTexareaProps> = ({
  twWidth = 'w-full md:w-[644px]',
  twHeight = 'h-auto',
  placeholder = '',
  value = '',
  disabled = false,
  focus = false,
  hideResize = false,
  onChange = () => {},
}) => {
  const inputRef = useRef<HTMLTextAreaElement>(null);
  useEffect(() => {
    if (focus && inputRef.current) inputRef.current.focus();
  }, [focus]);

  return (
    <div className={cn('block relative', twWidth, twHeight)}>
      <Textarea
        value={value}
        disabled={disabled}
        ref={inputRef}
        placeholder={placeholder}
        onChange={onChange}
        className={cn(
          'group/input grid gap-4 items-center relative h-full pr-[8px] pl-[20px] z-10 w-full',
          hideResize ? 'resize-none' : 'resize-y',
          twHeight
        )}
      />
      <Background />
    </div>
  );
};

const Background: FC = () => {
  const base =
    'block absolute top-0 left-0 w-full h-full pointer-events-none z-0';

  const getPartClasses = (part: TextareaPart): string =>
    [part.default, part.hover, part.focus, part.disabled].join(' ');

  const bg = getPartClasses(textareaState.bg);
  const border = getPartClasses(textareaState.border);

  return (
    <>
      <div className={cn(base, bg, 'backdrop-blur-md', uiInput.bg)} />
      <div className={cn(base, border, uiInput.border)} />
    </>
  );
};

export default BPTextarea;
